




































































import { doLogin, verifyLoginCode } from "@/services/login.service";
import axios from "axios";
import { availableLanguages } from "@/services/translate.service";
import LanguageSelector from "@/components/LanguageSelector.vue";

export default {
  data() {
    return {
      formEmail: "",
      formLang: "de",
      formPwd: "",
      error: false,
      errorMessage: "",
      languages: [],
      step: "credentials",
      challengeId: "",
      formCode: "",
      attemptsLeft: null,
    };
  },
  watch: {
    formLang: function (val) {
      this.$i18n.locale = val
    },
  },

  methods: {
    login: function () {
      this.error = false;
      this.attemptsLeft = null;

      this.$store.commit("auth_request");

      doLogin({ email: this.formEmail, password: this.formPwd, lang: this.$i18n.locale }).then((x) => {
        console.log(x);
        if (x.status === "2fa_required") {
          this.challengeId = x.challengeId;
          this.formCode = "";
          this.step = "code";
          return;
        }
        if (x.status == "error") {
          this.error = true;
          this.errorMessage = x.message;
          this.$store.commit("auth_error");
          localStorage.removeItem("token");
          return;
        }
        this.applyLogin(x.data);
      });
    },

    verifyCode: function () {
      this.error = false;
      this.attemptsLeft = null;

      verifyLoginCode(this.challengeId, this.formCode, this.$i18n.locale).then((x) => {
        console.log("verifyLoginCode response", x);
        if (x.status === "success") {
          if (!x.data || !x.data.token) {
            console.error("[verifyCode] success ohne data.token", x);
            this.error = true;
            this.errorMessage = "Login-Antwort unvollständig (token fehlt). Bitte Screenshot an den Support.";
            return;
          }
          this.applyLogin(x.data);
          return;
        }
        this.error = true;
        this.errorMessage = x.message;
        if (typeof x.attemptsLeft === "number") {
          this.attemptsLeft = x.attemptsLeft;
        }
        if (x.attemptsLeft === 0 || /erneut anmelden/i.test(x.message || "")) {
          this.step = "credentials";
          this.formCode = "";
        }
      }).catch((e) => {
        console.error("[verifyCode] exception", e);
        const err = e || {};
        const response = err.response || {};
        const httpStatus = response.status;
        const httpData   = response.data || {};
        this.error = true;
        this.errorMessage =
          "Verifikation fehlgeschlagen.\n" +
          "HTTP-Status: " + (httpStatus || "(keiner)") + "\n" +
          "Nachricht: " + (err.message || httpData.message || "Unbekannter Fehler");
      });
    },

    resendCode: function () {
      this.step = "credentials";
      this.formCode = "";
      this.attemptsLeft = null;
      this.login();
    },

    applyLogin: function (data) {
      const token = data.token;
      const user = data.user;
      const role = data.role;
      const company_id = data.company_id;

      this.$store.state.user_role = role;
      localStorage.setItem("user_role", JSON.stringify(role));
      this.$store.state.company_id = company_id;
      localStorage.setItem("company_id", company_id);

      this.$store.state.lang = this.formLang
      console.log('lang', this.$store.state.lang);

      axios.defaults.headers.common['x-lang'] = this.$store.state.lang

      localStorage.setItem("lang", this.formLang);

      localStorage.setItem("token", token);
      axios.defaults.headers.common["x-access-token"] = token;
      this.$store.commit("auth_success", { token, user });
      this.$router.push({ name: "overview" });
    },

    onLanguageChanged(language: any) {
      this.formLang = language.locale;
      console.log('onLanguageChanged', language);
    },

    keyUp: function (ev) {
      if (ev.keyCode == 13) {
        this.login();
      }
    },

    codeKeyUp: function (ev) {
      if (ev.keyCode == 13) {
        this.verifyCode();
      }
    },
  },
  mounted() {
    const languages = availableLanguages();
    console.log('i18n', this.$i18n.availableLocales);
    languages.forEach(l => {
      this.languages.push({ name: this.$i18n.t(l), locale: l },)

    });
    console.log('mounted', languages, this.languages);

  },
  components: {
    LanguageSelector
  }

};
